import { Component, Inject } from '@angular/core';
import { TrpcAPIService } from '../../trpc-api.service';
import { inferRouterOutputs } from '@trpc/server';
import { AppRouter } from '@server/src';
import { DialogService } from '@progress/kendo-angular-dialog';
import { KlantFormComponent } from '../klant-form/klant-form.component';
import { ReleaseNotesComponent } from '../../release-notes/release-notes.component';
import {envelopIcon, pencilIcon, trackChangesIcon} from "@progress/kendo-svg-icons";

type RouterOutput = inferRouterOutputs<AppRouter>;
type KlantenList = RouterOutput['klanten']['listKlanten'];
@Component({
  selector: 'klant-list',
  templateUrl: './klant-list.component.html',
  styles: `
  .kendo-grid-custom {
    max-height: 85vh;
  }
  .kop-link {
    color: #3f51b5;
  }
  .wrapper {
    display: flex;
    flex-direction: column;
    align-items: end;
  }
  `,

})
export class KlantListComponent {

  public editIcon =  pencilIcon;

  constructor(@Inject('ServerApi')public apiService: TrpcAPIService, private dialogService: DialogService) {
    this.queryKlanten();
  }

  public klanten: KlantenList = [];


  async queryKlanten() {
    let q = await this.apiService.client.klanten.listKlanten.query();

    this.klanten = q.map(x => ({
      ...x,
      FULLNAAM: x.VOORNAAM + ' ' + x.ACHTERNAAM
    }));
  }

  onNewKlant() {
    const dialogRef = this.dialogService.open({
      content: KlantFormComponent,
      width: 800,
    });
  }

  async onEditKlant(klantNo: string) {
    let klantinfo = await this.apiService.getKlantInfo(klantNo);
    console.log(klantinfo);
    const dialogRef = this.dialogService.open({
      content: KlantFormComponent,
      width: 800,
    });
    let di = dialogRef.content.instance as KlantFormComponent;
    di.kopInfo = klantinfo;
    di.klantNo = klantNo;
    di.isEdit = true;

  }

  showReleaseNotes() {
    this.dialogService.open({
      title: 'Release Notes',
      content: ReleaseNotesComponent,
      width: 700,
    });
  }

  protected readonly icon = trackChangesIcon;
}
